import { formatters } from "@equiem/web-ng-lib";

export const parseLocalDate = (dateStr: string): Date => {
  const [year, month, day] = dateStr.split("-").map(Number);

  return new Date(year, month - 1, day);
};

export const formatEndDate = (endDate: string, locale: string): string =>
  formatters.dateday(parseLocalDate(endDate), locale);

export const formatDateRange = (startDate: string, endDate: string, locale: string): string => {
  const start = formatters.dateday(parseLocalDate(startDate), locale);
  const end = formatters.dateday(parseLocalDate(endDate), locale);

  return `${start} - ${end}`;
};
